import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useBreakpoints, useFacets } from 'hooks';
import DelimitedItemInput from 'ui/DelimitedItemInput';

import messages from './messages';

interface IProps {
  onClose?: () => void;
}

const ItemSearchModal = ({ onClose = () => null }: IProps) => {
  const { isMobile } = useBreakpoints();
  const {
    itemSearchType,
    itemSearchValues,
    handleItemSearchChange,
    applyFacets,
  } = useFacets();

  const handleApply = useCallback(() => {
    applyFacets();
    onClose();
  }, [applyFacets, onClose]);

  return (
    <Dialog open onClose={onClose} fullScreen={isMobile}>
      <DialogTitle>
        <FormattedMessage {...messages.modalHeader} />
      </DialogTitle>
      <DialogContent>
        <DelimitedItemInput
          type={itemSearchType}
          values={itemSearchValues}
          onChange={handleItemSearchChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='outlined'>
          <FormattedMessage {...messages.cancelText} />
        </Button>
        <Button onClick={handleApply} variant='contained'>
          <FormattedMessage {...messages.applyText} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItemSearchModal;
